/**
 * Mirrors server/clientDirectory.js `clientKeyForQuote`, so a screen that only
 * knows a quotation can open that quotation's client.
 * Draft fields count when the saved client record never received them.
 */
export function clientKeyForQuote(quote?: {
  id?: string;
  client?: { email?: string; phoneE164?: string; phone?: string; mobile?: string };
  draft?: { recipientEmail?: string; clientPhone?: string } | null;
} | null): string {
  const client = quote?.client || {};
  const draft = quote?.draft || {};
  const email = String(client.email || draft.recipientEmail || '').trim().toLowerCase();
  if (email) return `email:${email}`;
  const digits = String(client.phoneE164 || client.phone || client.mobile || draft.clientPhone || '').replace(/\D/g, '');
  if (digits) return `phone:+${digits}`;
  return `orphan:${quote?.id || 'unknown'}`;
}
